<div class="container-fluid">
  <div class="row toppart">
    <div class="col-sm-12 col-lg-3 logo">
      <img class="" src="../../../../assets/images/logo.svg" alt="english logo" *ngIf="!isArabic" />
      <img class="" src="../../../../assets/images/ar_logo.svg" alt="arabic logo" *ngIf="isArabic" />
      <span class="customertype" *ngIf="CustomerType">{{CustomerType}}</span>
    </div>
    <div class="col-sm-12 col-lg-6 amlSection">
      <!--<span *ngIf="!isArabic">Risk Assessment Portal</span>
            <span *ngIf="isArabic">بوابة تقييم المخاطر</span>-->
      <!-- <span *ngIf="!isArabic">SupTech - Risk Assessment</span>
            <span *ngIf="isArabic">تقييم المخاطر - SupTech</span> -->
      <!-- <span *ngIf="!isArabic">Anti-Money Laundering/Combating the Financing of Terrorism Risk Assessment</span>
            <span *ngIf="isArabic">تقييم مخاطر مواجهة غسل الأموال وتمويل الإرهاب</span> -->
      <!-- <span *ngIf="!isArabic"
        >UBO Inspection Portal</span
      > -->
      <span *ngIf="!isArabic">Company Compliance</span>
      <span *ngIf="isArabic">امتثال الشركات</span>

    </div>
    <div class="col-sm-12 col-lg-3 right quesSection">
      <ul class="user-link">

        <li class="lang" (click)="chooseLanguage(false)" *ngIf="isArabic">
          <span>English</span>
        </li>
        <!-- <li><img src="../../../../assets/images/line.png" alt="" class="dividerLang"></li> -->
        <li class="lang" (click)="chooseLanguage(true)" *ngIf="!isArabic">
          <span>عربى</span>
        </li>
        <li  class="lang switch-entity" *ngIf="showPopupAccount">
          <a class="switch-entity-a" (click)="switchAccount(); $event.preventDefault()">
            Switch Entity
          </a>
        </li>
        <li (click)="goToDashboard()" class="homeLink">
          <!-- <span *ngIf="!isArabic" style="cursor: pointer;">Home</span>
                    <span *ngIf="isArabic" style="cursor: pointer;">مسكن</span> -->
          <img src="../../../../assets/images/home.svg" alt="" class="homeIcon" />
        </li>
        <!-- <li>
          <img
            src="../../../../assets/images/line.png"
            alt=""
            class="divider"
          />
        </li> -->
        <li>
          <span (click)="goToUserProfile()">
            <img src="../../../../assets/images/user.svg" alt="" class="userProfileIcon" />
          </span>
          <span (click)="goToUserProfile()" style="cursor: pointer" class="userName">{{
            userName
            }}</span>
        </li>
        <!-- <li><img src="../../../../assets/images/line.png" alt="" class="divider"></li> -->
        <li (click)="logout()">
          <a class="nav-link logout">
            <img src="../../../../assets/images/logout.svg" alt="" class="logoutIcon" />
            <span *ngIf="!isArabic" class="Logout-Text">Logout</span>
            <span *ngIf="isArabic">تسجيل الخروج</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>